import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(["idPaglieraniContactPricing"]),
        getByContact: state => id => {
            return state.objs.find(pricing => pricing.contact == id);
        },
        getByReferenceAgent: state => id => {
            return state.objs.filter(pricing => pricing.referenceAgent && pricing.referenceAgent === id);
        },
        getBySubagent: state => id => {
            return state.objs.filter(pricing => pricing.subagent && pricing.subagent === id);
        },
    },
    mutations: {
        ...functions.createDefaultMutations(["idPaglieraniContactPricing"]),
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idPaglieraniContactPricing']),
    },
}